var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.121,
    height: 18.121,
    viewBox: "0 0 18.121 18.121",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4322",
    transform: "translate(-522.439 -518.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "video-camera",
    d: "M3.2,1.6A1.6,1.6,0,0,0,1.6,3.2V6.4A1.6,1.6,0,0,0,3.2,8H8A1.6,1.6,0,0,0,9.6,6.4V3.2A1.6,1.6,0,0,0,8,1.6Zm7.984,1.284L12.8,1.268A1.6,1.6,0,0,1,13.931.8H14.4A1.6,1.6,0,0,1,16,2.4V7.2a1.6,1.6,0,0,1-1.6,1.6h-.469A1.6,1.6,0,0,1,12.8,8.331L11.184,6.716A3.2,3.2,0,0,1,8,9.6H3.2A3.2,3.2,0,0,1,0,6.4V3.2A3.2,3.2,0,0,1,3.2,0H8a3.2,3.2,0,0,1,3.184,2.884ZM13.932,7.2H14.4V2.4h-.469l-2.4,2.4,2.4,2.4ZM4,6.4a.8.8,0,1,1,.8-.8A.8.8,0,0,1,4,6.4Z",
    transform: "translate(523 522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_240",
    y1: 16,
    x2: 16,
    transform: "translate(523.5 519.5)",
    fill: "none",
    stroke: "#dc2e2e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera-off.5ce49a991a949d9dbf475560d9f1da08.svg";